<template>
  <section class="world-section">
    <div class="nature-container">
      <div class="clouds-bg clouds__1"></div>
      <div class="clouds-bg clouds__2"></div>
      <div class="swain-bg"></div>
      <div class="nature-picture">
        <img
          :src="require('@/assets/image/world-section/nature.jpg')"
          alt="nature"
          class="nature">
        <img
          :src="require('@/assets/image/world-section/mountain_lg.png')"
          alt="mountain_lg"
          class="mountain_lg">
        <img
          :src="require('@/assets/image/world-section/mountain_sm.png')"
          alt="mountain_sm"
          class="mountain_sm">
        <img
          :src="require('@/assets/image/world-section/mountain_xs.png')"
          alt="mountain_xs"
          class="mountain_xs">
        <img
          :src="require('@/assets/image/world-section/goats.png')"
          alt="goats"
          class="goats">
      </div>
    </div>
    <div class="container nature-text-container">
      <div class="about">
        <div class="about__heading">
          <span>№6</span> Мир <br> открывается заново
        </div>
        <div class="about__text">
          Пока мы сидели дома, природа настолько очистилась,
          что в каналы Венеции вернулись лебеди, в Индии
          рассеялся смог и стали видны вершины Гималаев,
          а в Великобритании горные козлы захватили улицы
          одного из городов. В следующем году наши путешествия
          станут куда насыщенней, а фотографии еще ярче
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';

export default {
  name: 'v-world-section',
  mounted() {
    const timelineWorld = gsap.timeline({
      scrollTrigger: {
        trigger: '.world-section',
        start: '-=70%',
        end: 'bottom',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress6:', self.progress);
          document.body.style.background = '#F4F4F4';
          TweenMax.to('.spotify-element__logo-container', {
            opacity: 0,
          });
        },
      },
    });
    timelineWorld.addLabel('start')
      .to('.clouds__1', {
        duration: 1,
        backgroundPositionX: '300%',
      })
      .to('.clouds__2', {
        duration: 1,
        backgroundPositionX: '-200%',
      }, '-=1')
      .to('.swain-bg', {
        duration: 1,
        backgroundPositionX: '60%',
      }, '-=0.5')
      .to('.mountain_lg', {
        duration: 1,
        y: -20,
      }, '-=0.5')
      .to('.mountain_sm', {
        duration: 1,
        y: -30,
      }, '-=1')
      .to('.mountain_xs', {
        duration: 1,
        y: -40,
      }, '-=1')
      .to('.goats', {
        duration: 1,
        y: -40,
      }, '-=1');
  },
};
</script>

<style lang="scss">
.world-section{
  position: relative;
  padding-top: 240px;
  z-index: 10;
  background-color: #f4f4f4;
}
.nature-container{
  width: 100%;
  max-width: 540px;
  position: relative;
  margin: 0 auto;

  img{
    max-width: 100%;
  }
}
.clouds-bg{
  width: 100%;
  height: 360px;
  position: absolute;
  top: -210px;
  z-index: 10;
  background-image: url("../assets/image/world-section/clouds.png");
  background-repeat: no-repeat;
}
.swain-bg{
  width: 100%;
  height: 56px;
  position: absolute;
  top: 100px;
  z-index: 15;
  background-image: url("../assets/image/world-section/swans.png");
  background-repeat: no-repeat;
  background-size: 95px;
  background-position: -30% center;
}

.clouds{

  &__1{
    top: -180px;
    background-position: -100% center;
  }
  &__2{
    background-position: 200% center;
  }
}

.nature-picture{
  overflow: hidden;
  position: relative;
}
.nature{
  z-index: 12;
}
.mountain_lg{
  z-index: 13;
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 270px;
  left: 0;
}
.mountain_sm{
  z-index: 14;
  position: absolute;
  width: 100%;
  bottom: -30px;
  height: 200px;
  left: 0;
}
.mountain_xs{
  z-index: 15;
  position: absolute;
  width: 100%;
  bottom: -50px;
  height: 170px;
  left: 0;
}
.goats{
  z-index: 16;
  position: absolute;
  width: 100%;
  bottom: -70px;
  height: 146px;
  left: 0;
}
.nature-text-container{
  position: relative;
  z-index: 20;
  width: 100%;
  padding-top: 50px;

  &:after, &:before{
    content: '';
    width: 61px;
    height: 61px;
    display: block;
    position: absolute;
    top: -61px;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &:after{
    left: 0;
    background-image: url('../assets/image/world-section/corner-left.svg');
  }

  &:before{
    right: 0;
    background-image: url('../assets/image/world-section/corner-right.svg');
  }
}
</style>
